import { lazy } from 'react';
import { profileTypes } from './constants/userConstants';
import { solutionConstants } from './constants/solutionsConstants';
import { ListUsers } from '../views/Users/ListUsers';
import { UserDetails } from '../views/UserDetails/UserDetails';
import ExamType from '../views/CustomList/components/customLists/Customlist';
import CustomList from '../views/CustomList/CustomList';
import WidgetsExternal from '../views/WidgetsExternal/WidgetsExternal';
import Api from '../views/Api/Api';
import { ChatUpdateDecorator } from '../views/Chat/menuItem/chatUpdatesDecorator';

const ChatApp = lazy(() => import('../views/Chat/ChatApp2'));
const ChatHistory = lazy(() => import('../views/Chat/ChatHistory'));
const Asset = lazy(() => import('../views/Assets/Assets'));
// const AssetsCreate = lazy(() => import('../views/Assets/components/AssetsCreate'));
const Account = lazy(() => import('../views/Account/components/Account'));
const AssetDetails = lazy(() => import('../views/AssetDetails/AssetDetails'));
const AssetTypes = lazy(() => import('../views/AssetTypes/assetTypes'));
const Stock = lazy(() => import('../views/Inventory/stock/Stock'));
const SurveyGroup = lazy(() => import('../views/Surveys/surveysGroup/components/SurveysGroup'));
const SurveyHistory = lazy(() => import('../views/Surveys/surveysHistory/components/SurveyHistory'));

const EditSurveyHistory = lazy(() =>
  import('../views/Surveys/surveysHistory/components/editSurveyHistory/EditSurveyHistory'),
);
const SurveyHistoryDetails = lazy(() =>
  import('../views/Surveys/surveysHistory/components/surveyHistoryDetails/components/SurveyHistoryDetails'),
);
const IncidentTypesOptions = lazy(() => import('../views/ServiceTypesOptions/IncidentTypesOptions'));
const Answersfrequents = lazy(() => import('../views/Answersfrequent/components/Answersfrequent'));
const NoteTypesItems = lazy(() => import('../views/AccountSetting/components/tabs/NoteTypesItems/NoteTypesItems'));
const CancellationReassonsItems = lazy(() =>
  import('../views/AccountSetting/components/tabs/CancellationReassonsItems/CancellationReassonsItems'),
);
const FinalCustomerTags = lazy(() =>
  import('../views/AccountSetting/components/tabs/FinalCustomerTagsItems/FinalCustomerTagsItems'),
);
const FinalCustomerDetails = lazy(() => import('../views/FinalCustomerDetail/FinalCustomerDetails'));
const HeadquarterDetails = lazy(() => import('../views/HeadquartersDetail/HeadquartersDetails'));
const LegalPageSettings = lazy(() => import('../views/Legal/LegalPageSettings'));
const IntegrationWhatsappPage = lazy(() => import('../views/IntegrationWhatsapp/IntegrationWhatsappPage'));
const WhatsappCreateMessage = lazy(() => import('../views/MessengerService/whatsapp/components/WhatsappCreateMessage'));
const Whatsapp = lazy(() => import('../views/MessengerService/whatsapp/components/Whatsapp'));
const PdfSettings = lazy(() => import('../views/PdfSettings/PdfSettings'));
const EditPdf = lazy(() => import('../views/PdfSettings/tabs/personalized/editPdf/EditPdf'));
const VideoConsultation = lazy(() => import('../views/VideoConsultationPage/VideoConsultationPage'));
const UserDevicesLogs = lazy(() => import('../views/Users/components/userDevices/components/UserDevicesLogs'));
const UserDevices = lazy(() => import('../views/Users/components/userDevices/components/UserDevices'));
const WhatsappMessageViewDetails = lazy(() =>
  import('../views/MessengerService/whatsapp/components/WhatsappMessageViewDetails'),
);
const EditIncidentTypesNotifications = lazy(() =>
  import('../views/ServiceTypesNotificationDetails/EditIncidentTypeNotifications'),
);
const IncidentTypesNotifications = lazy(() => import('../views/ServiceTypesNotifications/IncidentTypesNotifications'));
const IncidentTypes = lazy(() => import('../views/IncidentTypes/IncidentTypes'));
const ServicesHistory = lazy(() => import('../views/ServicesHistory/ServicesHistory'));
const ServicesHistoryDetails = lazy(() => import('../views/ServicesHistoryDetails/ServicesDetail'));
const PendingsBoard = lazy(() => import('../views/PendingsBoard/PendingsBoard'));
const SelfScheduling = lazy(() => import('../views/SelfScheduling/SelfScheduling'));
const AppointmentPageSettings = lazy(() => import('../views/AppointmentsPageSettings/AppointmentPageSettings'));
const Dashboard = lazy(() => import('../views/Dashboard/Dashboard'));
const Reports = lazy(() => import('../views/Reports/Reports'));
const Modules = lazy(() => import('../views/Modules/Modules'));
const Accounts = lazy(() => import('../views/Accounts/Accounts'));
const Calendar = lazy(() => import('../views/Calendar/Calendar'));
const CustomReportsSettingsTable = lazy(() =>
  import('../views/AccountSetting/components/tabs/CustomReportsSettingsTable'),
);
const CustomReportsSettingsDetail = lazy(() =>
  import('../views/AccountSetting/components/tabs/customReportsSettings/CustomReportsSettingsDetail'),
);
const CustomerDetails = lazy(() => import('../views/CustomerDetails/CustomerDetails'));
const Customers = lazy(() => import('../views/Customers/Customers'));
const FinalCustomers = lazy(() => import('../views/FinalCustomers/FinalCustomers'));
const Skills = lazy(() => import('../views/Skills/Skills'));
const AccountSetting = lazy(() => import('../views/AccountSetting/AccountSetting'));
const IncidentTypeDetails = lazy(() => import('../views/IncidentTypeDetails/IncidentTypeDetails'));
const Headquarters = lazy(() => import('../views/Headquarters/Headquarters'));
const Personalization = lazy(() => import('../views/Personalization/Personalization'));
const Availability = lazy(() => import('../views/Availability/Availability'));
const AwaitingList = lazy(() => import('../views/AwaitingList/AwaitingList'));
const AwaitingListSettingsPage = lazy(() => import('../views/AwaitingList/component/AwaitingListSettings'));
const Sequences = lazy(() => import('../views/Sequences/Sequences'));
const FlowTemplates = lazy(() => import('../views/FlowTemplates/FlowTemplates'));
const FlowTemplateCanvasPage = lazy(() => import('../views/FlowTemplates/FlowTemplateCanvasPage'));
const Workflows = lazy(() => import('../views/Workflows/Workflows'));
const WorkflowDetail = lazy(() => import('../views/Workflows/WorkflowDetail'));
const PaymentGateways = lazy(() => import('../views/PaymentGateways/PaymentGateways'));
const HtmlSettings = lazy(() => import('../views/PdfSettings/tabs/htmlForms/components/HtmlSettings'));
const ArchivesTemplatesForm = lazy(() =>
  import('../views/PdfSettings/tabs/archiveTemplates/components/ArchivesTemplatesForm'),
);
const TechniciansTracking = lazy(() => import('../views/TechniciansTracking/TechniciansTracking'));
const BillingConfiguration = lazy(() => import('../views/BillingConfiguration/BillingConfiguration'));
const BillingServices = lazy(() => import('../views/BillingServices/BillingServices'));
const BillingServiceDetail = lazy(() => import('../views/BillingServiceDetail/BillingServiceDetail'));
const CreditNoteDetail = lazy(() => import('../views/CreditNoteDetail/CreditNoteDetail'));
const AdjustmentNoteDetail = lazy(() => import('../views/AdjustmentNoteDetail/AdjustmentNoteDetail'));
const FinalCustomerSettings = lazy(() =>
  import('../views/AccountSetting/components/tabs/ContentFinalCustomerSettings'),
);

const AssetsGeolocalization = lazy(() => import('../views/AssetsGeolocalization/AssetsGeolocalization'));
const Statistics = lazy(() => import('../views/statistics/Statistics'));
const InventoryItems = lazy(() => import('../views/Inventory/items/Items'));
const InventoryConfiguration = lazy(() => import('../views/Inventory/configuration/Configuration'));
const InventoryMovements = lazy(() => import('../views/Inventory/movements/Movements'));
const MovementsCreate = lazy(() => import('../views/Inventory/movements/MovementsCreate'));
const ItemDetails = lazy(() => import('../views/Inventory/items/itemDetails/ItemDetails'));
const FormsDetail = lazy(() => import('../views/FormDetail/FormDetail'));
const Forms = lazy(() => import('../views/Forms/Forms'));
const ChatConfiguration = lazy(() => import('../views/Chat/components/chatConfiguration/ChatConfiguration'));

// const CustomList = lazy(() => import('../views/customList/CustomList'));

export const defaultPath = '/auth/login';

export const Routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    icon: 'bar-chart-2',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: Dashboard,
    checkPermissions: (permissions) => permissions.canViewDashboard,
  },
  {
    path: '/accounts',
    name: 'accounts',
    icon: 'bar-chart-2',
    profiles: [profileTypes.MASTER.id],
    checkPermissions: (permissions) => !permissions.manageAccounts,
    component: Accounts,
  },
  {
    path: '/calendar/:tab?',
    name: 'calendar',
    icon: 'calendar',
    profiles: [profileTypes.OPERATOR.id, profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.TECHNICIAN.id],
    component: Calendar,
    checkPermissions: (permissions) => permissions.canViewCalendar,
    collapseMenu: true,
  },
  {
    path: '/incident-type',
    redirect: true,
    name: 'incident-type',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    component: IncidentTypeDetails,
  },

  {
    path: '/customers',
    name: 'customers',
    icon: 'home',
    moduleName: 'customers',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => permissions.canViewCustomers,
    component: Customers,
  },
  {
    path: '/support-chat/:chatId?',
    name: 'supportChat',
    icon: 'info',
    moduleName: 'supportChat',
    profiles: [profileTypes.OPERATOR.id],
    component: ChatApp,
    decorator: ChatUpdateDecorator,
  },
  {
    path: '/support-chat-history',
    name: 'chatHistory',
    icon: 'info',
    moduleName: 'supportChat',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    component: ChatHistory,
    decorator: ChatUpdateDecorator,
  },
  {
    path: '/customers/:id/:tab?',
    redirect: true,
    name: 'customers',
    icon: 'shopping-bag',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: CustomerDetails,
  },
  {
    path: '/final-customer/',
    name: 'finalCustomers',
    icon: 'users',
    moduleName: 'finalCustomers',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
    component: FinalCustomers,
    checkPermissions: (permissions) => permissions.canViewFinalCustomers,
  },
  {
    path: '/final-customer/:id/:tab?',
    redirect: true,
    name: 'finalCustomers',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
    component: FinalCustomerDetails,
    checkPermissions: (permissions) => permissions.canViewFinalCustomers,
  },
  {
    path: '/incident-type/:id/notifications',
    redirect: true,
    name: 'incidentTypeNotifications',
    icon: 'mail',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    component: IncidentTypesNotifications,
  },
  {
    path: '/incident-type/:incidentTypeId/edit-notifications/:notificationId?',
    redirect: true,
    name: 'incidentTypeNotifications',
    icon: 'mail',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    component: EditIncidentTypesNotifications,
  },
  {
    path: '/incident-type/:id/options/:tab?/',
    redirect: true,
    name: 'incidentTypeNotifications',
    icon: 'mail',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    component: IncidentTypesOptions,
  },
  {
    path: '/services-history/',
    name: 'servicesHistory',
    icon: 'list',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id, profileTypes.INTERESTED.id],
    component: ServicesHistory,
    getSiblings: ({ topics }) => topics,
    checkPermissions: (permissions, currentUserProfile) =>
      currentUserProfile === profileTypes.INTERESTED.id || permissions.canViewServicesHistory,
  },
  {
    path: '/workflows',
    name: 'workflows',
    icon: 'git-merge',
    moduleName: 'workFlows',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => permissions.administrateWorkflows,
    component: Workflows,
  },
  {
    path: '/workflows/:workflowId',
    name: 'workflowDetail',
    moduleName: 'workFlows',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => permissions.administrateWorkflows,
    component: WorkflowDetail,
  },
  {
    path: '/pendings-board/',
    name: 'pendingsBoard',
    moduleName: 'pendingsBoard',
    newTab: true,
    icon: 'trello',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: PendingsBoard,
  },
  {
    isContainer: true,
    name: 'inventory',
    // redirect: true,
    moduleName: 'inventory',
    path: '/inventory',
    icon: 'package',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => permissions.administrateInventory,

    children: [
      {
        path: '/inventory-stock',
        name: 'stock',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: Stock,
      },
      {
        path: '/inventory-movements',
        name: 'movements',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: InventoryMovements,
      },
      {
        path: '/inventory-items/',
        name: 'items',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: InventoryItems,
      },
      {
        path: '/inventory-configuration/:tab?',
        name: 'configuration',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: InventoryConfiguration,
        checkPermissions: (permissions) => permissions.canConfigureInventory,
      },
    ],
  },
  {
    path: '/tracking-technicians/',
    name: 'techniciansTracking',
    icon: 'map-pin',
    moduleName: 'resourcesTracking',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: TechniciansTracking,
    checkPermissions: (permissions) => permissions.canViewResourceTracking,
  },
  {
    path: '/assets-geolocalization/',
    name: 'assetsGeolocalization',
    icon: 'map-pin',
    moduleName: 'assetGeolocalization',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: AssetsGeolocalization,
    // checkPermissions: (permissions) => permissions.canViewResourceTracking,
  },
  {
    path: '/statistics/',
    name: 'statistics',
    icon: 'pie-chart',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
    component: Statistics,
    solutionIds: [solutionConstants.TAPPTUS.id],
  },
  {
    isContainer: true,
    name: 'surveys',
    // redirect: true,
    moduleName: 'surveys',
    path: '/surveys',
    icon: 'copy',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
    checkPermissions: (permissions) => permissions.canViewSurveys,

    children: [
      {
        path: '/surveys-group',
        name: 'surveysGroup',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
        checkPermissions: (permissions) => permissions.canViewSurveys,
        component: SurveyGroup,
      },
      {
        path: '/survey-history/',
        name: 'surveyHistory',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
        checkPermissions: (permissions) => permissions.canViewSurveys,
        component: SurveyHistory,
      },
    ],
  },
  {
    isContainer: true,
    path: '/awaiting-list',
    name: 'awaitingList',
    icon: 'share',
    moduleName: 'awaitingList',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
    children: [
      {
        path: '/list',
        name: 'list',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
        component: AwaitingList,
      },
      {
        path: '/settings',
        name: 'configuration',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.MASTER.id],
        component: AwaitingListSettingsPage,
      },
    ],
  },
  {
    path: '/services-detail/:id/:tab?/:subPath?/',
    redirect: true,
    name: 'servicesHistory',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id, profileTypes.INTERESTED.id],
    component: ServicesHistoryDetails,
  },
  {
    path: '/headquarters/:id/:tab?',
    redirect: true,
    name: 'headquarters',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: HeadquarterDetails,
  },
  {
    path: '/incident-type-details/:incidentTypeId/:tab?',
    redirect: true,
    name: 'editIncidentType',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    component: IncidentTypeDetails,
  },
  {
    path: '/incident-type/:incidentTypeId/self-scheduling/',
    name: 'autoScheudling',
    icon: 'calendar',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    component: SelfScheduling,
  },
  {
    path: '/availability/',
    name: 'availability',
    icon: 'clock',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
    component: Availability,
    moduleName: 'advancedAvailability',
    checkPermissions: (permissions) => {
      return permissions.administrateAdvancedAvailability;
    },
  },
  {
    isContainer: true,
    name: 'billing',
    moduleName: 'electronicInvoicing',
    path: '/billing',
    icon: 'folder-plus',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],

    children: [
      {
        path: '/billing-services/:tab',
        name: 'billingServices',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: BillingServices,
        checkPermissions: (permissions) => {
          return permissions.canCreateInvoices;
        },
      },

      {
        path: '/billing-configuration/:tab?',
        name: 'billingConfiguration',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: BillingConfiguration,
        checkPermissions: (permissions) => {
          return permissions.canViewBillingSettings;
        },
      },
      {
        path: '/billing-configuration/:tab?/create',
        name: 'billingConfigurationDetail',
        redirect: true,
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: BillingConfiguration,
      },
      {
        path: '/billing-configuration/:tab?/edit/:id?',
        name: 'billingConfigurationDetail',
        redirect: true,
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: BillingConfiguration,
      },
      {
        path: '/billing-configuration/:tab?/detail/:id?',
        name: 'billingConfigurationDetail',
        redirect: true,
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: BillingConfiguration,
      },
    ],
  },
  {
    path: '/billing-service-detail/:id?',
    name: 'billingServicesDetail',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: BillingServiceDetail,
    checkPermissions: (permissions) => {
      return permissions.canCreateInvoices;
    },
  },
  {
    path: '/billing-invoice-detail/:idInvoice?',
    name: 'billingInvoiceDetail',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => {
      return permissions.canCreateInvoices;
    },
    component: BillingServiceDetail,
  },
  {
    path: '/credit-note-detail/:id?',
    name: 'creditNoteDetail',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => {
      return permissions.canCreateCreditNotes;
    },
    component: CreditNoteDetail,
  },
  {
    path: '/adjustment-note-detail/:id?',
    name: 'adjustmentNoteDetail',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => {
      return permissions.canCreateAdjustmentNotes;
    },
    component: AdjustmentNoteDetail,
  },
  {
    isContainer: true,
    name: 'config',
    path: '/settings',
    icon: 'settings',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    children: [
      {
        path: '/users',
        name: 'users',
        icon: 'person',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
        checkPermissions: (permissions, currentUserProfile) =>
          currentUserProfile !== profileTypes.SUPERVISOR.id || permissions.canManageUsers,
        component: ListUsers,
      },
      {
        path: '/headquarters/',
        name: 'headquarters',
        icon: 'layout',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
        component: Headquarters,
      },
      {
        path: '/skills/',
        name: 'skills',
        icon: 'layout',
        profiles: [profileTypes.ADMIN.id],
        component: Skills,
      },
      {
        path: '/incident-type/',
        name: 'serviceTypes',
        icon: 'database',
        profiles: [profileTypes.ADMIN.id],
        component: IncidentTypes,
      },
      {
        path: '/chat-configuration/',
        name: 'chatConfiguration',
        moduleName: 'supportChat',
        profiles: [profileTypes.ADMIN.id],
        component: ChatConfiguration,
      },
      {
        path: '/appointments-landing-page/:tab?',
        defaultPath: '/appointments-landing-page/info',
        name: 'selfScheduling',
        icon: 'layout',
        profiles: [profileTypes.ADMIN.id],
        moduleName: 'selfSchedulingPage',
        component: AppointmentPageSettings,
      },

      {
        path: '/accountSetting/:tab?',
        name: 'accountSetting',
        icon: 'book-open',
        profiles: [profileTypes.ADMIN.id],
        component: AccountSetting,
      },
      {
        path: '/customLists',
        name: 'customLists',
        icon: '',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        checkPermissions: (permissions) => permissions.canViewCustomLists,
        component: CustomList,
      },
      {
        path: '/final-customer-settings',
        name: 'finalCustomerSettings',
        icon: '',
        redirect: true,
        profiles: [profileTypes.ADMIN.id],
        component: FinalCustomerSettings,
      },
      {
        path: '/frequent-answers',
        name: 'answersFrequent',
        icon: '',
        profiles: [profileTypes.ADMIN.id, profileTypes.OPERATOR.id],
        component: Answersfrequents,
        moduleName: 'supportChat',
        checkPermissions: (permissions) => permissions.administrateQuickAnswers,
      },
      {
        path: '/custom-report-settings',
        name: 'customReportSettings',
        icon: '',
        redirect: true,
        profiles: [profileTypes.MASTER.id],
        component: CustomReportsSettingsTable,
      },
      {
        path: '/asset-types',
        name: 'assetTypes',
        icon: '',
        moduleName: 'asset',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: AssetTypes,
        checkPermissions: (permissions) => permissions.canViewAssets,
      },
      {
        path: '/sequences/',
        name: 'sequences',
        moduleName: 'supportChat',
        profiles: [profileTypes.ADMIN.id],
        component: Sequences,
      },
      {
        path: '/flow-templates',
        name: 'flowTemplates',
        moduleName: 'workFlows',
        profiles: [profileTypes.ADMIN.id],
        component: FlowTemplates,
      },
      {
        path: '/flow-templates/:templateId/canvas',
        name: 'flowTemplateCanvas',
        moduleName: 'workFlows',
        redirect: true,
        profiles: [profileTypes.ADMIN.id],
        component: FlowTemplateCanvasPage,
      },
      {
        path: '/pdf-settings/:tab?',
        name: 'documents',
        icon: '',
        profiles: [profileTypes.ADMIN.id],
        component: PdfSettings,
        moduleName: 'pdfSettings',
      },
      {
        path: '/custom-pdf-format/:id?',
        name: 'pdfCreate',
        redirect: true,
        profiles: [profileTypes.ADMIN.id],
        component: EditPdf,
        moduleName: 'pdfSettings',
      },
      {
        path: '/html-forms/:id?',
        name: 'htmlForms',
        redirect: true,
        profiles: [profileTypes.ADMIN.id],
        component: HtmlSettings,
        moduleName: 'pdfSettings',
      },
      {
        path: '/archives-template-form/:id?',
        name: 'archivesTemplateForm',
        redirect: true,
        profiles: [profileTypes.ADMIN.id],
        component: ArchivesTemplatesForm,
        moduleName: 'pdfSettings',
      },
      {
        path: '/forms',
        name: 'forms',
        icon: '',
        moduleName: 'forms',
        profiles: [profileTypes.ADMIN.id, profileTypes.OPERATOR.id, profileTypes.SUPERVISOR.id],
        component: Forms,
      },
    ],
  },
  {
    isContainer: true,
    name: 'messengerService',
    path: '/messengerService',
    icon: 'message-circle',
    moduleName: 'messaging',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    children: [
      {
        path: '/whatsapp/',
        name: 'whatsapp',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
        component: Whatsapp,
        moduleName: 'messaging',
      },
      {
        path: '/whatsapp/details/:id?',
        redirect: true,
        name: 'whatsappMessageViewDetails',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: WhatsappMessageViewDetails,
      },
      {
        path: '/whatsapp/cretaeMessage/',
        redirect: true,
        name: 'whatsappMessageViewDetails',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
        component: WhatsappCreateMessage,
      },
    ],
  },
  {
    path: '/reports',
    name: 'reports',
    icon: 'file-text',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: Reports,
  },
  {
    isContainer: true,
    name: 'administration',
    path: '/administration',
    icon: 'grid',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    children: [
      {
        path: '/modules/',
        name: 'modules',
        profiles: [profileTypes.MASTER.id],
        component: Modules,
      },
      {
        path: '/widgets-external/',
        name: 'widgetsExternal',
        profiles: [profileTypes.ADMIN.id],
        component: WidgetsExternal,
      },
      {
        path: '/personalization',
        name: 'personalization',
        icon: '',
        profiles: [profileTypes.ADMIN.id],
        component: Personalization,
        checkPermissions: (permissions) => {
          return permissions.enableAccountCustomization;
        },
      },
      {
        path: '/api/',
        name: 'api',
        profiles: [profileTypes.ADMIN.id],
        component: Api,
        checkPermissions: (permissions) => {
          return permissions.enableAccountAPI;
        },
      },
      {
        path: '/integration-whatsapp/',
        name: 'integrationWhatsapp',
        profiles: [profileTypes.ADMIN.id],
        component: IntegrationWhatsappPage,
      },
      {
        path: '/legal/:tab?',
        name: 'legal',
        profiles: [profileTypes.ADMIN.id],
        component: LegalPageSettings,
      },
      {
        path: '/payment-gateways/',
        name: 'paymentGateways',
        profiles: [profileTypes.ADMIN.id],
        component: PaymentGateways,
      },
      {
        path: '/account',
        name: 'account',
        profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
        component: Account,
      },
    ],
  },
  {
    path: '/user/:userId?/:tab?',
    name: 'userDetails',
    icon: 'person',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    checkPermissions: (permissions, currentUserProfile) =>
      currentUserProfile !== profileTypes.SUPERVISOR.id || permissions.canManageUsers,
    component: UserDetails,
  },
  {
    path: '/user-devices-logs/:id?',
    name: 'userDevicesLogs',
    icon: '',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    checkPermissions: (permissions, currentUserProfile) =>
      currentUserProfile !== profileTypes.SUPERVISOR.id || permissions.canManageUsers,
    component: UserDevicesLogs,
  },
  {
    path: '/user-devices/:id?',
    name: 'userDevices',
    icon: '',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id],
    checkPermissions: (permissions, currentUserProfile) =>
      currentUserProfile !== profileTypes.SUPERVISOR.id || permissions.canManageUsers,
    component: UserDevices,
  },

  {
    path: '/survey-history-edit/:surveyId?',
    name: 'EditSurveyHistory',
    redirect: true,
    icon: '',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
    component: EditSurveyHistory,
    checkPermissions: (permissions) => permissions.canViewSurveys,
  },
  {
    path: '/survey-history-details/:surveyId?',
    name: 'surveyHistoryDetails',
    redirect: true,
    icon: '',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id],
    component: SurveyHistoryDetails,
    checkPermissions: (permissions) => permissions.canViewSurveys,
  },

  {
    path: '/custom-report-settings-detail/:customReportId?',
    name: 'customReportSettingsDetail',
    redirect: true,
    profiles: [profileTypes.MASTER.id],
    component: CustomReportsSettingsDetail,
  },
  {
    path: '/customLists/:customListId?',
    name: 'ExamType',
    icon: 'person',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => permissions.canViewCustomLists,
    component: ExamType,
  },
  {
    path: '/service-notes-types',
    name: 'noteTypeDetails',
    redirect: true,
    profiles: [profileTypes.ADMIN.id],
    component: NoteTypesItems,
  },
  {
    path: '/service-cancellation-reassons',
    name: 'noteTypeDetails',
    redirect: true,
    profiles: [profileTypes.ADMIN.id],
    component: CancellationReassonsItems,
  },
  {
    path: '/final-customer-tags',
    name: 'finalCustomerTags',
    redirect: true,
    profiles: [profileTypes.ADMIN.id],
    component: FinalCustomerTags,
  },
  {
    path: '/asset/:id?',
    name: 'asset',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => permissions.canViewAssets,
    component: Asset,
  },
  {
    path: '/assets/create/:idAssetType?',
    name: 'assetCreate',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => permissions.canViewAssets,
    component: AssetDetails,
  },
  {
    path: '/movements-create/:id?/',
    name: 'movements',
    redirect: true,
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: MovementsCreate,
  },
  {
    path: '/assets/:id/:tab?',
    redirect: true,
    name: 'assetsDetails',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    checkPermissions: (permissions) => permissions.canViewAssets,
    component: AssetDetails,
  },
  {
    path: '/video-consultation/',
    redirect: true,
    moduleName: 'videoConsultationRoom',
    name: 'VideoConsultation',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.TECHNICIAN.id, profileTypes.OPERATOR.id],
    component: VideoConsultation,
  },

  {
    path: '/inventory-item/:id/:tab?',
    redirect: true,
    name: 'InventoryDetails',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: ItemDetails,
  },

  {
    path: '/formDetail/:id?/:tab?',
    redirect: true,
    name: 'forms',
    profiles: [profileTypes.ADMIN.id, profileTypes.SUPERVISOR.id, profileTypes.OPERATOR.id],
    component: FormsDetail,
  },

];
